import { DynamicContent } from '@commblades/commblades';
// eslint-disable-next-line import/no-unresolved
import { Accordion, AccordionContent, AccordionHeader } from '@honeycomb-npm/honeycomb-react';

import { DisclaimerH2Wrapper, DisclaimerWrapper } from './Disclaimer.styled';

export interface DisclaimerProps {
    heading: string;
    description: string;
    accordionHeader?: string;
    accordionContent?: string;
}
const Disclaimer = ({
    heading, description, accordionHeader, accordionContent,
}:DisclaimerProps) => (
    <DisclaimerWrapper>
        <DisclaimerH2Wrapper className="pd-2" id="disclaimer-heading">{heading}</DisclaimerH2Wrapper>
        <DynamicContent content={description} id="disclaimer-description" />
        {accordionHeader && accordionContent
                && (
                    <Accordion collapseAll className="" isAccordion>
                        <AccordionHeader id="all-terms-header" targetContentId="all-terms-content">
                            {accordionHeader}
                        </AccordionHeader>
                        <AccordionContent id="all-terms-content" targetHeaderId="all-terms-header">
                            <DynamicContent content={accordionContent} id="disclaimer-content" />
                        </AccordionContent>
                    </Accordion>
                )}
    </DisclaimerWrapper>
);

export default Disclaimer;
